import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IClippingResult {
  id: string;
  name: string;
  createdAt: Date;
  startingDate: Date;
  phrases: string[][];
}

interface IComparisonResult {
  id: string;
  namespace: string;
  displayName: string;
  isDefault: boolean;
  createdAt: string;
  colors: string[];
  sourceTypeOnm: 'clipping' | 'label';
  __typename: string;
}

interface IPrintBroadcastMediaState {
  printClippingList: IClippingResult[];
  printComparisonList: IComparisonResult[];
  broadcastClippingList: IClippingResult[];
  broadcastComparisonList: IComparisonResult[];
}

const initialState: IPrintBroadcastMediaState = {
  printClippingList: [],
  printComparisonList: [],
  broadcastClippingList: [],
  broadcastComparisonList: []
};

export const printAndBroadcastMedia = createSlice({
  name: 'printAndBroadcastMedia',
  initialState,
  reducers: {
    reducerUpdatePrintClippingList: (
      state: IPrintBroadcastMediaState,
      action: PayloadAction<IClippingResult[]>
    ) => {
      state.printClippingList = action.payload;
    },
    reducerUpdatePrintComparisonList: (
      state: IPrintBroadcastMediaState,
      action: PayloadAction<IComparisonResult[]>
    ) => {
      state.printComparisonList = action.payload;
    },
    reducerUpdateBroadcastClippingList: (
      state: IPrintBroadcastMediaState,
      action: PayloadAction<IClippingResult[]>
    ) => {
      state.broadcastClippingList = action.payload;
    },
    reducerUpdateBroadcastComparisonList: (
      state: IPrintBroadcastMediaState,
      action: PayloadAction<IComparisonResult[]>
    ) => {
      state.broadcastComparisonList = action.payload;
    }
  }
});

export const {
  reducerUpdatePrintClippingList,
  reducerUpdatePrintComparisonList,
  reducerUpdateBroadcastClippingList,
  reducerUpdateBroadcastComparisonList
} = printAndBroadcastMedia.actions;

export default printAndBroadcastMedia.reducer;
